export default "__VITE_ASSET__BRYoU$nW__";